import { Cell, InfoLabel } from 'bold-ui'
import { ReactComponent as EarIcon } from 'images/antropometria/ear.svg'
import { ReactComponent as BicepsIcon } from 'images/antropometria/flexed-biceps-outline.svg'
import { ReactComponent as SkinIcon } from 'images/antropometria/skin-outline.svg'
import React, { Fragment } from 'react'
import { getForcaMuscularRenderText } from 'view/atendimentos/detail/components/modals/medicoes/exame-fisico/utils-medicaoAnteriorExameFisico'

import { AntropometriaAccordionModel } from './AntropometriaAccordion'
import { AntropometriaGridItem } from './AntropometriaGridItem'

interface PacMedicoesReadOnlyProps {
  values: Pick<
    AntropometriaAccordionModel,
    | 'pele'
    | 'olhoDireito'
    | 'olhoEsquerdo'
    | 'ouvidoDireito'
    | 'ouvidoEsquerdo'
    | 'valorForcaMuscMaoDireita'
    | 'unidadeForcaMuscMaoDireita'
    | 'valorForcaMuscMaoEsquerda'
    | 'unidadeForcaMuscMaoEsquerda'
  >
}

export function PacMedicoesReadOnly(props: Readonly<PacMedicoesReadOnlyProps>) {
  const { values } = props

  return (
    <Fragment>
      <AntropometriaGridItem icon={<SkinIcon />} titulo='Pele'>
        <Cell size={12} alignSelf='center'>
          <InfoLabel title='Observações'>{values?.pele}</InfoLabel>
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem iconName='eyeOutline' titulo='Olhos'>
        <Cell size={6}>
          <InfoLabel title='Olho direito'>{values?.olhoDireito}</InfoLabel>
        </Cell>
        <Cell size={6}>
          <InfoLabel title='Olho esquerdo'>{values?.olhoEsquerdo}</InfoLabel>
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem icon={<EarIcon />} titulo='Ouvidos'>
        <Cell size={6}>
          <InfoLabel title='Ouvido direito'>{values?.ouvidoDireito}</InfoLabel>
        </Cell>
        <Cell size={6}>
          <InfoLabel title='Ouvido esquerdo'>{values?.ouvidoEsquerdo}</InfoLabel>
        </Cell>
      </AntropometriaGridItem>
      <AntropometriaGridItem icon={<BicepsIcon />} titulo='Avaliação de força muscular'>
        <Cell size={6}>
          <InfoLabel title='Mão direita'>
            {getForcaMuscularRenderText(values?.valorForcaMuscMaoDireita, values?.unidadeForcaMuscMaoDireita?.enum)}
          </InfoLabel>
        </Cell>
        <Cell size={6}>
          <InfoLabel title='Mão esquerda'>
            {getForcaMuscularRenderText(values?.valorForcaMuscMaoEsquerda, values?.unidadeForcaMuscMaoEsquerda?.enum)}
          </InfoLabel>
        </Cell>
      </AntropometriaGridItem>
    </Fragment>
  )
}
